export class PromptModel {
    constructor() {
        this.model_params = "";
        this.domain = "";
    }
}
export class PromptModelResponse {
}
